import customAxios from "./axiosConfig";

const ReportsService = {
    get: function (id, params) {
        var api_url = window.Urls['vatreport_detail'](id);
        return customAxios.get(api_url, { params: params });
    },
    list: function (params) {
        var api_url = window.Urls['vatreport-list']();
        return customAxios.get(api_url, { params: params });
    },
    update: function (id, data, params) {
        var api_url = window.Urls['vatreport-detail'](id);
        return customAxios.patch(api_url, data, { params: params });
    },
    create: function (data) {
        var api_url = window.Urls['vatreport-list']();
        return customAxios.post(api_url, data);
    },
    status: function (data) {
        var api_url = window.Urls['vatreport-status']();
        return customAxios.get(api_url, data);
    },
    count: function (params) {
        var api_url = window.Urls['vatreport_count']();
        return customAxios.get(api_url, { params: params });
    },
    destroy: function (id) {
        var api_url = window.Urls['vatreport-detail'](id);
        return customAxios.delete(api_url);
    },
    updateQ4ShowCorrectionTrigger: function (id, data) {
        var api_url = window.Urls['vatreport-update-q4-show-correction-trigger'](id);
        return customAxios.post(api_url, data);
    },
    getPDFBlob (id) {
        const api_url = window.Urls['vatreport-download-pdf'](id)
        return customAxios.get(api_url, { responseType: 'blob' }).then((response) => {
            return response
        })
    },
};

export default ReportsService;